"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { CollapsibleItem } from "./collapsible-item";
import { FAQ } from "./types";
import { toSentenceCase } from "@/utils/string/to-sentence-case";
interface TabContentProps {
  faqs: FAQ[];
}
export function TabContent(t0) {
  const $ = _c(15);
  const {
    faqs
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Set();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [openItems, setOpenItems] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = index => {
      setOpenItems(prev => {
        const newSet = new Set(prev);
        if (newSet.has(index)) {
          newSet.delete(index);
        } else {
          newSet.add(index);
        }
        return newSet;
      });
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const toggleItem = t2;
  let t3;
  if ($[2] !== faqs[0] || $[3] !== faqs.length) {
    t3 = faqs.length > 0 ? toSentenceCase(faqs[0].category) : "";
    $[2] = faqs[0];
    $[3] = faqs.length;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const categoryName = t3;
  let t4;
  if ($[5] !== categoryName) {
    t4 = categoryName && <h2 className="text-2xl text-center font-semibold text-gray-800 mb-6">{categoryName} FAQs</h2>;
    $[5] = categoryName;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== faqs || $[8] !== openItems) {
    let t6;
    if ($[10] !== openItems) {
      t6 = (faq, index_0) => <CollapsibleItem key={index_0} faq={faq} isOpen={openItems.has(index_0)} onToggle={() => toggleItem(index_0)} />;
      $[10] = openItems;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    t5 = faqs.map(t6);
    $[7] = faqs;
    $[8] = openItems;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <div className="space-y-4">{t4}{t5}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}